import React from 'react'

const CustomerRefundPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Refund Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we aim to provide seamless household management. We understand that sometimes things don’t go as planned. Whether it’s a cleaning service that did not meet your expectations or a repair service that was ineffective, our refund policy is designed to be transparent, fair, and fast.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>How to Request a Refund: The Step-by-Step Guide</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we’ve streamlined our refund process to be as fast as possible. To ensure your request is processed without delays, please follow these four steps within 24 hours of your service completion.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Step 1: Initiation via the Maidly App</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    For security and tracking purposes, refund requests should be submitted through the Maidly app. Requests made outside the app may delay processing or affect eligibility. All refunds must be logged through the platform for security and auditing.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Open the Maidly App and tap on the "Activity" or "Bookings" tab.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Locate the specific service (e.g., "Deep Cleaning - Feb 6th") and tap on it to open the booking details.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Step 2: Selecting the Issue Category</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To help our Quality Assurance (QA) team understand the problem, you will be asked to choose a reason for the refund:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Quality of Work</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Professional Conduct</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Damage Claim</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Billing Error</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Step 3: Providing "Visual Evidence"</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For quality and damage-related claims, Maidly requires evidence.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Photo Uploads:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Provide clear photos/videos showing the issue, including timestamps or relevant context if possible.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Description:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Briefly explain what went wrong. For example: "The plumber fixed the leak, but it started dripping again 30 minutes after he left."</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Step 4: Submission &amp; The "Maidly Review"</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Once you hit "Submit Request," our system creates a support ticket.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Freeze" Period:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We may temporarily hold the payout to the service professional while we investigate.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>A Maidly Support Specialist may contact you via the app to clarify details or arrange a rectification visit if required.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Support Ticket:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Upon submission, a ticket ID will be generated to track your refund request.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Eligibility for a Refund</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we assess refund eligibility based on the "Service Contract" established at the time of booking. This refund policy does not affect your statutory consumer rights under applicable law. Refund requests are typically reviewed within 24–72 business hours. To be eligible for a refund or a credit, your situation must fall into one of the following four categories:
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Significant Service Deficiency</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>This applies when the core task you paid for was either not completed or performed poorly.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incomplete Scope:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The professional skipped specific areas listed in the "What's Included" section of the app (e.g., a deep clean that missed the inside of the microwave).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Technical Failure:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A repair service (Plumbing, Electrical, AC) that fails within 48 hours of completion.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incorrect Service:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the professional’s skill does not match the booked service, resulting in a service that cannot be used as intended.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Professional No-Show</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We value your time. You are eligible for a refund if:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "No-Show":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The professional does not arrive at your location and does not answer calls or messages within 30 minutes of the scheduled start time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Excessive Delay:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The professional arrives more than 60 minutes late without prior notification, making it impractical to continue the service.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Safety or Conduct Violations</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Safety is a non-negotiable pillar of the Maidly experience.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unprofessional Behavior:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Evidence of verbal abuse, identity mismatch (someone else showed up instead of the verified professional), or violation of house rules.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Theft or Damage:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a theft is reported (accompanied by an FIR) or accidental damage occurs that renders the service experience void.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Duplicate or Erroneous Charges</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>System Glitches:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You were charged twice for the same Booking ID due to a network error.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incorrect Add-ons:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You were billed for "Material Costs" or "Extra Hours" that you did not authorize through the app.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>The "Maidly Quality Audit" (How We Verify Eligibility)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Before a refund is approved, our team performs a "Triple-Check" to maintain fairness:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>GPS Geofencing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We verify if the professional was physically present at your address during the logged work hours.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Work Log" Review:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We check the "Before &amp; After" photos uploaded by the professional in their Maidly Partner App.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Communication Logs:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We review the in-app chat and call logs to see if any issues were raised or resolved during the service.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Cancellation Fees</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    When you book a service on Maidly, a professional reserves that time slot specifically for you and often turns down other work. To protect their livelihood and cover logistics, the following fee structure applies:
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. The Free Cancellation Window</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Advance Notice:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Cancellations made more than 48 hours before the scheduled start time are 100% free. Any pre-paid amount will be fully refunded to your original payment method or Maidly Wallet.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Mistake" Grace Period:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you make a booking by mistake and cancel it within 15 minutes of placing the order, no fee will be charged, provided the professional has not already started their journey.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Late Cancellation</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you cancel between 2 and 24 hours before the service:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Fee:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The applicable cancellation fee will be displayed in the app during the cancellation process.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Reason:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}This fee covers the administrative costs of rescheduling and helps Maidly find a replacement job for the professional on short notice.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Last-Minute Cancellation (The "On-The-Way" Fee)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you cancel less than 2 hours before the service:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Fee:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A charge of 50% of the base service fee will apply.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Reason:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}At this stage, the professional may already be in transit. This fee compensates them for their travel time and lost work opportunity.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. On-Door Cancellation &amp; No-Show</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If the professional arrives and you deny entry or are unavailable, 100% of the base service fee will be applied. This ensures the professional is compensated for their time and travel.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You are not home and cannot be reached for 15 minutes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You deny the professional entry to the premises.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You decide you no longer need the service once the professional is at your door.</span>
                                </li>
                            </ul>
                            <p>
                                <strong>The Fee:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}The full base service fee will be charged to compensate the professional for reserved time and travel. This ensures the professional is fully paid for their time and travel to your doorstep.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Refund Timelines</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Once a refund is approved by the Maidly Quality Assurance team, the speed at which you receive your funds depends on your chosen payout method. Refund timelines may vary depending on banking processes or public holidays.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. The Maidly Wallet</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Timeline:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}5-7 Business Days</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Process:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The amount is credited as "Maidly Credits" to your in-app wallet.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Benefit:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These credits can be used immediately for your next booking. This is the fastest way to get your money back without waiting for banking cycles.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Digital Payments (UPI, Wallets like Paytm/PhonePe)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Timeline:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}24 to 48 Hours.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Process:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once we initiate the refund, the UPI switch or digital wallet usually processes the transaction within a business day. You will receive an SMS from your provider once the credit is successful.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Credit/Debit Cards &amp; Net Banking</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Timeline:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}5 to 7 Business Days.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Process:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}This is the standard banking "settlement" period. Maidly releases the funds immediately, but your bank may take 5–7 business days to process the refund and update your statement.</span>
                                </li>
                            </ul>
                            <p>
                                <strong>Note:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}During public holidays or bank strikes, this may take up to 10 days.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly reserves the right to approve, partially approve, or deny any refund after reviewing evidence, booking records, and platform logs. Misuse of the refund system may lead to temporary restrictions or suspension of account access, in accordance with our Terms of Service. This Refund Policy is designed to ensure fairness and transparency. Nothing in this policy limits or replaces your rights under applicable consumer protection laws.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If Maidly determines that a refund request contains false, misleading, or manipulated evidence, or if there is a pattern of repeated refund abuse, the user’s repeated misuse of the refund policy may result in restrictions on your account. Refund eligibility may be affected if the service scope is altered before Maidly completes its quality review.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Non-Refundable Scenarios</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we strive to be as flexible as possible. Refunds are not issued if the professional cannot complete the service due to circumstances beyond their control. However, to ensure our service partners are not unfairly penalized, refunds will not be issued in the following circumstances:
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Access and Availability Issues</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Locked Door" Scenario:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the professional arrives at the scheduled time but cannot gain access to your home (e.g., you are not home, the security guard denies entry, or the digital lock code provided is incorrect).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unreachable Customer:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the professional waits for the mandatory 15-minute grace period and attempts to call/message you multiple times without a response.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incorrect Address:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the service could not be performed because the address provided in the Maidly app was incorrect or incomplete.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Utility and Environment Constraints</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Lack of Utilities:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the task cannot be completed due to a lack of essential utilities at the premises, such as no running water, no electricity, or inadequate ventilation for labor-intensive tasks.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Hazardous Conditions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the professional arrives and finds the environment unsafe (e.g., exposed high-voltage wires, aggressive unrestrained pets, or ongoing construction that prevents the booked task).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Material and Equipment Deficiencies</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Customer-Provided Supplies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you opted to provide your own cleaning chemicals or repair parts, and the service failed because the materials provided were expired, low-quality, or incorrect for the job.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Appliance Failure:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a cook or cleaner cannot perform their job because your kitchen appliances (stove, microwave, vacuum) are non-functional.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Scope and "Change of Mind"</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Completed Services:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once a service has been completed and the professional has checked out without any immediate issues raised, a refund cannot be issued simply because you "changed your mind" about needing the service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unauthorized Tasks:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Refunds are not available for tasks outside the original booking scope (e.g., requesting additional work not listed in the service).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Third-Party Interference:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Hiring another technician or attempting a DIY fix before Maidly’s QA inspection will void your refund eligibility.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Conduct and Policy Violations</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Platform Bypassing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you attempted to pay the professional in cash or negotiated a deal outside the Maidly app, refunds and platform protection may not be applicable if the service is arranged outside the app.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Late Reporting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any quality-based claim submitted after the 24-hour window from the time of service completion.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly may update this Refund Policy from time to time in accordance with applicable laws. Material changes will be communicated through the app or registered contact details. Continued use of the app constitutes acceptance of the updated policy. All refunds are processed to the original payment method unless otherwise required by law.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Contact Our Billing Team</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For any questions regarding a pending refund, please reach out to:</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Please include your Booking ID to help us process your request faster.</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerRefundPolicy